/**
 * @GENERATED from Figma node 3608:51013
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const GoogleMailDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#34A853"
      d="M17.238 19.238h3.333c.79 0 1.429-.626 1.429-1.4V7.81l-4.762 3.499z"
    />
    <path
      fill="#4285F4"
      d="M3.429 19.238h3.333v-7.93L2 7.809v10.03c0 .773.64 1.399 1.429 1.399"
    />
    <path
      fill="#EA4335"
      fillRule="evenodd"
      d="M6.761 11.619v-6.19L12 9.238l5.239-3.81v6.19L12 15.429z"
      clipRule="evenodd"
    />
    <path
      fill="#FBBC04"
      d="M17.238 5.432v6.187L22 8.049V6.146c0-1.765-2.015-2.773-3.428-1.714z"
    />
    <path
      fill="#C5221F"
      d="M2 6.146v1.903l4.762 3.57V5.432l-1.333-1C4.015 3.373 2 4.381 2 6.146"
    />
  </svg>
);
const ForwardRef = React.forwardRef(GoogleMailDark);
export { ForwardRef as GoogleMailDark };
